import { type, string, optional, array, number } from 'superstruct';
import { Sale } from '../../core/typescript/sale';
export const GiftBoxDescription = type({
    id: number(),
    description: optional(string())
});
export const CartDrawerIO = type({
    moneyFormat: string(),
    giftBoxesTooltipTitle: optional(string()),
    giftBoxesDescriptions: optional(array(GiftBoxDescription)),
    sale: optional(Sale)
});
